import { Box, Flex, NavLink, NavShopAllLink, ProductBadge, Text } from "@theme/components";

import type { NavCategory, NavSubCategory } from "@theme/types";
import type { FC } from "react";

interface NavProductListProps {
  navCategory: NavCategory;
  subCategory: NavSubCategory;
  closeNavigation: () => void;
}

// NOTE: this component is shadowed. All updates must be done in both gatsby-theme and gatsby-site
export const NavProductList: FC<NavProductListProps> = ({
  navCategory,
  subCategory,
  closeNavigation,
}) => {
  const subCategoryParams = subCategory.filterParams;

  const subCategoryUrl = subCategoryParams ? `?${subCategoryParams}` : "";

  return (
    <Box>
      <Flex
        as="ul"
        sx={{
          margin: 0,
          padding: 0,
          listStyle: "none",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: ["s400", null, null, "s500"],
          alignSelf: "stretch",
        }}
      >
        {subCategory.products
          .filter((product) => product.slug && product.active)
          .map((product, index) => (
            <Box as="li" key={index}>
              <NavLink
                variant="box"
                role="link"
                to={product.pageSlug}
                sx={{
                  "&:hover": {
                    "& .subtitle": {
                      color: "grey700",
                    },
                  },
                }}
                onClick={closeNavigation}
              >
                {product.productBadge && (
                  <Box
                    sx={{
                      display: "inline-flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      pb: "s100",
                    }}
                  >
                    <ProductBadge {...product.productBadge} sx={{ mb: 0 }} />
                  </Box>
                )}

                <Text
                  className="title"
                  variant="sansBody02Regular"
                  sx={{
                    color: "grey700",
                    display: "block",
                  }}
                >
                  {product.title}
                </Text>

                <Text
                  className="subtitle"
                  variant="sansBody01Regular"
                  sx={{
                    color: "grey500",
                    lineHeight: "lh300",
                    display: "block",
                  }}
                >
                  {product.subtitle}
                </Text>
              </NavLink>
            </Box>
          ))}
      </Flex>
      <NavShopAllLink
        to={`${navCategory.pageSlug}${subCategoryUrl}`}
        onClick={closeNavigation}
        text={subCategory.shopAllCTAText}
        ariaLabel={subCategory.shopAllCTAText}
        sx={{ my: "s400" }}
      />
    </Box>
  );
};
